import { useEffect, useState } from "react";

/**
 * Rotating idle-state puns for the Argus empty chat state. Modelled after the
 * `QA_JOKES` loader on the /generate page but with the copy steered toward
 * Argus' "hundred-eyed sentinel" branding.
 */
export const ARGUS_PUNS: readonly string[] = [
  "Argus has a hundred eyes, but zero ideas until you speak up.",
  "Your sandboxed sidekick is wide awake. Whisper sweet nothings (or test plans).",
  "A watchful agent is a bored agent. Give it something to chase.",
  "Argus has read your CLAUDE.md. Now it wants to put that knowledge to work.",
  "Hundred eyes, one keyboard. Ready when you are.",
  "Argus is pacing in the sandbox. Throw it a bone (or a bug).",
  "Think of Argus as a very polite bash shell. That also watches.",
  "Your wish is its tool call.",
  "Idle agents gather dust. Tell it what to see.",
  "Argus sees all, but guesses none. Start typing.",
];

/**
 * Hook that returns a pun from `ARGUS_PUNS`, rotating every `intervalMs`.
 * Starts at a random index so successive mounts don't always show the same copy.
 */
export function useRotatingArgusPun(intervalMs = 5000): string {
  const [index, setIndex] = useState(() => Math.floor(Math.random() * ARGUS_PUNS.length));

  useEffect(() => {
    const id = setInterval(() => {
      setIndex((prev) => (prev + 1) % ARGUS_PUNS.length);
    }, intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);

  return ARGUS_PUNS[index] ?? ARGUS_PUNS[0]!;
}
